module.exports = __webpack_public_path__ + "img/balkon.a38b035c.webp";